module.exports = __webpack_public_path__ + "static/media/hiw2yellow.b700de0f.svg";